/**
 * Axios HTTP Client
 *
 * Why: Centralized HTTP client with interceptors
 * What: Configured Axios instance with auth,error handling and logging
 * Benefit:
 *  - Single resource of truth for http config
 *  - Consistent request configuration
 *  - Automatic token attachemnt
 *  - Automatic error handling
 *  - Request/Response logging
 *  - Error transformation
 */

import axios, { type AxiosInstance } from "axios";
import { apiConfig } from "@/config";

import {
  requestInterceptor,
  requestErrorInterceptor,
  responseInterceptor,
  // responseErrorInterceptor,
  errorResponseInterceptor,
} from "./interceptors";
import { logger } from "../../utils";

/**
 * Creates and configures Axios instance
 */

const createAxiosClient = (): AxiosInstance => {
  // Create instance with default config
  const client = axios.create({
    baseURL: apiConfig.baseUrl,
    timeout: apiConfig.timeout,
    headers: apiConfig.headers,
    withCredentials: true,
  });

  // =======================
  // 🔹 Request Interceptors
  // =======================

  // Logger (first- logs raw request)
  // client.interceptors.request.use(
  //   loggerRequestInterceptor,
  //   undefined, //No error handler needed here
  // );

  // // Auth(second- adds token)
  // client.interceptors.request.use(
  //   authRequestInterceptor,
  //   authRequestErrorInterceptor,
  // );

  // Add request interceptor
  client.interceptors.request.use(requestInterceptor, requestErrorInterceptor);

  // =======================
  // 🔹 Response Interceptors
  // =======================

  // Logger (first- logs response before processing)
  // client.interceptors.response.use(
  //   loggerResponseInterceptor,
  //   loggerResponseErrorInterceptor,
  // );

  // // Error handler (second- handles errors)
  // client.interceptors.response.use(
  //   (response) => response, //Pass through successful responses
  //   errorResponseInterceptor,
  // );
  // Add response interceptor
  client.interceptors.response.use(
    responseInterceptor,
    // responseErrorInterceptor,
    errorResponseInterceptor,
  );
  logger.info("✅ Axios client initialized");
  return client;
};

// Export configured client instance
export const axiosClient = createAxiosClient();
